import React from 'react';

import { useFulfillmentPlannerContext } from '../context';

import DeliveryTime from './index';

const FulfillmentPlannerContextDeliveryTimeContainer = () => {
  const { deliveryTime } = useFulfillmentPlannerContext();

  return <DeliveryTime deliveryTime={deliveryTime} emptyValue='--' />;
};

export default FulfillmentPlannerContextDeliveryTimeContainer;
